import React from "react";
import "./SCrollDown.css";

const SCrollDown = ({onClick}) => {
  return (
    <div className="scroll-down">
      <div
        // href="#tt-page-content"
        className="scroll-down-inner"
        onClick={onClick}
        data-offset="0"
      >
        <div className="scroll-down-scrd-icon">
          <i className="fa fa-arrow-down" aria-hidden="true"></i>
        </div>
        <svg viewBox="0 0 500 500">
          <defs>
            <path
              d="M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250"
              id="textcircle"
            ></path>
          </defs>
          <text dy="30">
            <textPath xlinkHref="#textcircle">
              Scroll to Explore - Scroll to Explore -
            </textPath>
          </text>
        </svg>
      </div>
    </div>
  );
};

export default SCrollDown;
